import styles from './styles.module.css';
import EmptyData from '@/components/Form/EmptyData';
import Gauge from '@/components/Gauge';
import GridContainer from '@/components/GridContainer';
import WebSocketIndicator from '@/components/WebSocketIndicator';

interface SummaryTabProps {
  turbineSummary?: any;
  turbineStatus?: any;
  alarmCount?: number;
  shutdownCount?: number;
  showAlarmCount?: boolean;
}

export default function SummaryGauges({
  turbineSummary,
  alarmCount,
  shutdownCount,
  turbineStatus,
  showAlarmCount = true
}: SummaryTabProps) {
  return (
    <div className={styles.container}>
      <div className={styles.gaugesSection}>
        <div className={styles.sectionHeader}>
          {showAlarmCount && (
            <div className={styles.infoBoxes}>
              <div className={styles.infoBox}>
                <div className={styles.infoLabel}>Alarm Count</div>
                <div className={styles.infoValue}>{alarmCount || 0}</div>
              </div>
              <div className={styles.infoBox}>
                <div className={styles.infoLabel}>Shutdown Count</div>
                <div className={styles.infoValue}>{shutdownCount || 0}</div>
              </div>
            </div>
          )}
          <div className={styles.headerRight}>
            <WebSocketIndicator turbineStatus={turbineStatus} />
          </div>
        </div>
        <div className={styles.gaugesContainer}>
          {!turbineSummary || turbineSummary?.length === 0 ? (
            <EmptyData label="No summary data available" />
          ) : (
            <GridContainer minItemWidth="165px" gap="10px" align="center">
              {turbineSummary.map((item: any, index: number) => (
                <Gauge
                  size="small"
                  key={item.key || index}
                  mainLabel={item.label}
                  currentKw={parseFloat(item.value) || 0}
                  maxKw={parseFloat(item.max) || 1}
                />
              ))}
            </GridContainer>
          )}
        </div>
      </div>
    </div>
  );
}
